import type { EventConfig } from '@/types'
import type { SettingsSection } from '../../../server/lib/eventSettings'
import CameraSettings from '../pages/CameraSettings'
import AudioSettings from '../pages/AudioSettings'
import CaptureSettings from '../pages/CaptureSettings'
import ScreensaverSettings from '../pages/ScreensaverSettings'
import KioskSettings from '../pages/KioskSettings'

export default function SettingsSectionForm({ section, event, onChange }: {
  section: SettingsSection; event: EventConfig; onChange: (updates: Partial<EventConfig>) => void
}) {
  switch (section) {
    case 'camera': return <CameraSettings event={event} onChange={onChange} />
    case 'audio': return <AudioSettings event={event} onChange={onChange} />
    case 'screensaver': return <ScreensaverSettings event={event} onChange={onChange} />
    case 'slideshow': return <KioskSettings event={event} onChange={onChange} scope="presentation" />
    default: return <CaptureSettings event={event} onChange={onChange} section={section} />
  }
}
